import React, { useMemo } from 'react';
import OverviewSidepanelQuestion from './overview-sidepanel-question';
import { SurveyStats } from 'src/redux/survey/survey.types';

interface OverviewSidePanelProps {
  stats: SurveyStats;
}

const OverviewSidePanel: React.FC<OverviewSidePanelProps> = ({ stats }) => {


  const completionRate = useMemo(() => {
    const lastQuestionTotalUsers = stats.questions[stats.questions.length - 1].totalUsers;
    return `${((lastQuestionTotalUsers / stats.totalUsers) * 100).toFixed(1).replace('.0', '')}`;
  }, [stats.totalUsers, stats.questions]);

  return (
    <div className="bg-white rounded-lg shadow-md p-6 ml-4 max-w-[300px] ">
      <h2 className="text-lg font-light text-gray-800 mb-4">
        Overview
      </h2>
      <div className="flex flex-col gap-2 w-1/2">
        <div className='bg-gray-201 px-2 py-1 rounded-md'>
          <div className='font-normal text-gray-800 text-xs'>
            Completion Rate
          </div>
          <div className='font-light text-gray-800 text-2xl text-center'>
            {completionRate}
            %
          </div>
        </div>
        <div className='bg-gray-201 px-2 py-1 rounded-md'>
          <div className='font-normal text-gray-800 text-xs'>
            Total Users
          </div>
          <div className='font-light text-gray-800 text-2xl text-center'>
            {stats.totalUsers}
          </div>
        </div>


      </div>
      {/* Side panel content goes here */}
      <h2 className="text-lg font-light text-gray-800 mb-4 mt-2">
        Questions
      </h2>
      {stats?.questions.map((question, index) => (
        <OverviewSidepanelQuestion
          key={question.id}
          index={index}
          question={question}
        />
      ))}
    </div>
  );
};

export default OverviewSidePanel;
